import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AdminGetActualBalancesQueryVariables = Types.Exact<{
  limit?: Types.Maybe<Types.Scalars["Int"]>;
  offset?: Types.Maybe<Types.Scalars["Int"]>;
  search?: Types.Maybe<Types.Scalars["String"]>;
  orderBy?: Types.Maybe<Array<Types.Actual_Balances_Order_By>>;
}>;

export type AdminGetActualBalancesQuery = { __typename?: "query_root" } & {
  actual_balances: Array<
    { __typename?: "actual_balances" } & Pick<
      Types.Actual_Balances,
      | "balance"
      | "created_at"
      | "balance_gbp"
      | "balance_usd"
      | "balance_eur"
      | "id"
      | "date"
      | "interest_rate"
      | "maturity_date"
    > & {
        bank_account: { __typename?: "bank_accounts" } & Pick<
          Types.Bank_Accounts,
          | "id"
          | "account_id"
          | "product_type"
          | "notice_days"
          | "fixed_maturity_date"
        > & {
            bank?: Types.Maybe<
              { __typename?: "banks" } & Pick<Types.Banks, "id" | "name">
            >;
            currency: { __typename?: "currencies" } & Pick<
              Types.Currencies,
              "prefix"
            >;
            currency_book: { __typename?: "currency_books" } & Pick<
              Types.Currency_Books,
              "id"
            > & {
                business_unit: { __typename?: "business_units" } & Pick<
                  Types.Business_Units,
                  "id"
                > & {
                    organisation: { __typename?: "organisations" } & Pick<
                      Types.Organisations,
                      "id" | "name"
                    >;
                  };
              };
          };
      }
  >;
  actual_balances_aggregate: { __typename?: "actual_balances_aggregate" } & {
    aggregate?: Types.Maybe<
      { __typename?: "actual_balances_aggregate_fields" } & Pick<
        Types.Actual_Balances_Aggregate_Fields,
        "count"
      >
    >;
  };
};

export const AdminGetActualBalancesDocument = gql`
  query AdminGetActualBalances(
    $limit: Int
    $offset: Int
    $search: String
    $orderBy: [actual_balances_order_by!]
  ) {
    actual_balances(
      limit: $limit
      offset: $offset
      order_by: $orderBy
      where: {
        _or: [
          { bank_account: { account_id: { _ilike: $search } } }
          { bank_account: { bank: { name: { _ilike: $search } } } }
          {
            bank_account: {
              currency_book: {
                business_unit: { organisation: { name: { _ilike: $search } } }
              }
            }
          }
          { bank_account: { currency: { prefix: { _ilike: $search } } } }
        ]
      }
    ) {
      balance
      created_at
      balance_gbp
      balance_usd
      balance_eur
      id
      date
      bank_account {
        id
        account_id
        product_type
        notice_days
        fixed_maturity_date
        bank {
          id
          name
        }
        currency {
          prefix
        }
        currency_book {
          id
          business_unit {
            id
            organisation {
              id
              name
            }
          }
        }
      }
      interest_rate
      maturity_date
    }
    actual_balances_aggregate(
      where: {
        _or: [
          { bank_account: { bank: { name: { _ilike: $search } } } }
          {
            bank_account: {
              currency_book: {
                business_unit: { organisation: { name: { _ilike: $search } } }
              }
            }
          }
          { bank_account: { currency: { prefix: { _ilike: $search } } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export function useAdminGetActualBalancesQuery(
  options: Omit<
    Urql.UseQueryArgs<AdminGetActualBalancesQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<AdminGetActualBalancesQuery>({
    query: AdminGetActualBalancesDocument,
    ...options,
  });
}
